import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { apiLogin } from "../../../api/auth.api";
import { useData } from "../../../hooks/";

import bg1 from "assets/images/bg1.png";
import bg2 from "assets/images/bg2.png";
import bg3 from "assets/images/bg3.png";
import bg4 from "assets/images/bg4.png";
import bg5 from "assets/images/bg5.png";
import bg6 from "assets/images/bg6.png";
import bg7 from "assets/images/bg7.png";
import bg8 from "assets/images/bg8.png";
import bg9 from "assets/images/bg9.png";

function Basic() {
  const [userid, setUserid] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { saveUser } = useData();

  const backgrounds = [bg1, bg2, bg3, bg4, bg5, bg6, bg7, bg8, bg9];
  const [bgImage, setBgImage] = useState(bg1); // Default to bg1

  useEffect(() => {
    const randomBgImage = backgrounds[Math.floor(Math.random() * backgrounds.length)];
    setBgImage(randomBgImage);
  }, []);

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      const userResponse = await apiLogin({ userid, password });
      saveUser(userResponse.data);
      console.log(userResponse);
      navigate("/dashboard");
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            로그인
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={onSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="ID"
                fullWidth
                value={userid}
                onChange={(e) => setUserid(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit">
                시작하기
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
